import { useTabsStore } from '@/stores/tabs';
export const openSupplierPayment = async (props = {}) => {
  const { default: component } = await import(
    '@/views/payments/EmployeePaymentEditorView.vue'
  );
  const tabs = useTabsStore();
  const itemId =
    props.paymentId || (props.invoiceId ? `invoice:${props.invoiceId}` : null);
  const existing =
    tabs.tabs.find(
      (tab) =>
        tab.section === 'supplier-payment-editor' &&
        ((props.paymentId &&
          String(tab.props?.paymentId) === String(props.paymentId)) ||
          (props.invoiceId &&
            String(tab.props?.invoiceId) === String(props.invoiceId))),
    ) ||
    (itemId
      ? tabs.findMatchingTab({
          component,
          itemId,
          section: 'supplier-payment-editor',
        })
      : null);
  if (existing) {
    tabs.updateTab(existing.id, { props });
    tabs.activateTab(existing.id);
    return;
  }
  tabs.createTab({
    component,
    props,
    itemId,
    section: 'supplier-payment-editor',
    title: props.invoiceId
      ? 'Invoice appointments'
      : props.paymentId
        ? 'Supplier payment'
        : 'New Payment',
  });
};
